import { TurboForm } from "@finanedi.es/front/common/organisms"
import { useLeyAntiFraudeForm } from "./hooks"
import { ILeyAntiFraudeFormProps } from "./interfaces"

export const LeyAntiFraudeForm = ({
  onClose,
  nif,
  razonSocial,
  estado,
  motivo,
}: ILeyAntiFraudeFormProps) => {
  const formProps = useLeyAntiFraudeForm({
    onClose,
    nif,
    razonSocial,
    estado,
    motivo,
  })
  return <TurboForm {...formProps} />
}
